import React from "react";
import VoucherList from "../voucherList/VoucherList";

const MyVoucher = () => {
  return <VoucherList />;
};

export default MyVoucher;
